(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pbReady === 'true') return;
    root.dataset.pbReady = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var look = root.querySelector('[data-pb-look]');
    var beats = look ? look.querySelectorAll('[data-pb-beat]') : [];
    var stageCount = look ? look.querySelector('[data-pb-stage-count]') : null;
    var lastStage = -1;
    var temp = root.querySelector('[data-pb-temperature]');
    var slider = root.querySelector('#PbTemperature');
    var tempLabel = root.querySelector('[data-pb-temp-label]');
    var form = root.querySelector('.pb-access__form');
    var panel = root.querySelector('[data-pb-signup-panel]');
    var closeSignup = root.querySelector('[data-pb-signup-close]');
    var access = root.querySelector('#pb-early-access');
    var comparison = root.querySelector('.pb-comparison');
    var signupShown = false;
    var signupDismissed = false;
    var signupKey = 'coff-protein-black-signup-dismissed';
    try { signupDismissed = sessionStorage.getItem(signupKey) === 'true'; } catch (error) { /* Storage is optional. */ }

    var signupDialog = document.createElement('dialog');
    signupDialog.className = 'pb-signup-dialog';
    signupDialog.setAttribute('aria-labelledby', 'PbSignupHeading');
    var panelHome = document.createComment('Protein Black inline signup');
    if (panel && access) {
      panel.before(panelHome);
      access.appendChild(signupDialog);
    }
    function dismissSignup(remember) {
      if (!panel) return;
      if (signupDialog.open) signupDialog.close();
      panel.classList.remove('is-floating');
      if (panelHome.parentNode) panelHome.after(panel);
      if (closeSignup) closeSignup.hidden = true;
      if (remember) {
        signupDismissed = true;
        try { sessionStorage.setItem(signupKey, 'true'); } catch (error) { /* Storage is optional. */ }
        event('protein_black_signup_dismiss');
      }
    }
    if (closeSignup) closeSignup.addEventListener('click', function () { dismissSignup(true); });
    signupDialog.addEventListener('cancel', function (cancelEvent) {
      cancelEvent.preventDefault();
      dismissSignup(true);
    });
    var threshold50 = false;
    var threshold90 = false;
    var lookVisible = false;
    var scrollQueued = false;

    function event(name, details) {
      var data = details || {};
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data));
      window.dispatchEvent(new CustomEvent('coff:analytics', { detail: Object.assign({ event: name }, data) }));
    }

    function setMotion() {
      var animateLook = !reducedMotion.matches && window.matchMedia('(min-width: 900px) and (min-height: 650px)').matches;
      root.classList.toggle('pb--motion', animateLook);
      if (!animateLook && look) {
        Array.prototype.forEach.call(beats, function (beat) { beat.classList.remove('is-current'); });
        look.style.removeProperty('--pb-look-progress');
        lastStage = -1;
      }
      queueScroll();
    }

    function updateScroll() {
      scrollQueued = false;
      var doc = document.documentElement;
      var available = Math.max(1, doc.scrollHeight - window.innerHeight);
      var progress = window.scrollY / available;
      if (!threshold50 && progress >= .5) { threshold50 = true; event('protein_black_scroll_50'); }
      if (!threshold90 && progress >= .9) { threshold90 = true; event('protein_black_scroll_90'); }
      if (panel && access && form) {
        var accessRect = access.getBoundingClientRect();
        var accessVisible = accessRect.top < window.innerHeight && accessRect.bottom > 0;
        var hasResponse = form.querySelector('[data-pb-success], [data-focus-on-load]');

        if (typeof signupDialog.showModal === 'function' && !signupShown && !signupDismissed && !hasResponse && comparison && comparison.getBoundingClientRect().bottom <= window.innerHeight && !accessVisible && accessRect.top > window.innerHeight && !form.contains(document.activeElement)) {
          signupShown = true;
          signupDialog.appendChild(panel);
          panel.classList.add('is-floating');
          if (closeSignup) closeSignup.hidden = false;
          signupDialog.showModal();
          event('protein_black_signup_prompt_view');
        }
      }
      if (!lookVisible || !root.classList.contains('pb--motion')) return;
      var rect = look.getBoundingClientRect();
      var travel = Math.max(1, rect.height - window.innerHeight);
      var step = Math.max(0, Math.min(1, -rect.top / travel));
      var current = step < .16 ? 0 : step < .52 ? 1 : 2;
      look.style.setProperty('--pb-look-progress', step);
      if (current !== lastStage) {
        look.dataset.stage = String(current);
        if (stageCount) stageCount.textContent = '0' + (current + 1) + ' / 03';
        Array.prototype.forEach.call(beats, function (beat, index) {
          beat.classList.toggle('is-current', index === current);
        });
        lastStage = current;
      }
    }

    function queueScroll() {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(updateScroll);
    }

    if (look && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        lookVisible = entries[0].isIntersecting;
        if (lookVisible) queueScroll();
      }, { rootMargin: '100px 0px' });
      observer.observe(look);
    } else if (look) {
      lookVisible = true;
    }

    setMotion();
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', setMotion);
    window.addEventListener('scroll', queueScroll, { passive: true });
    window.addEventListener('resize', queueScroll, { passive: true });
    event('protein_black_page_view');

    root.querySelectorAll('[data-pb-early-click]').forEach(function (link) {
      link.addEventListener('click', function () { dismissSignup(false); signupShown = true; event('protein_black_early_access_click'); });
    });

    if (slider && temp) {
      var hasInteracted = false;
      slider.addEventListener('input', function () {
        var value = Math.max(0, Math.min(100, Number(slider.value) || 0));
        var label = value <= 20 ? 'Hot concept' : value >= 80 ? 'Iced concept' : 'Between hot and iced concepts';
        temp.style.setProperty('--temperature', value);
        slider.setAttribute('aria-valuetext', label);
        tempLabel.textContent = label;
        if (!hasInteracted) { hasInteracted = true; event('protein_black_hot_cold_interaction'); }
      });
    }

    if (form) {
      var successful = form.querySelector('[data-pb-success]');
      if (successful) {
        try { sessionStorage.setItem(signupKey, 'true'); } catch (error) { /* Storage is optional. */ }
        event('protein_black_email_submit', { result: 'success' });
        successful.focus();
      } else {
        form.addEventListener('submit', function (submitEvent) {
          if (form.dataset.submitting === 'true') { submitEvent.preventDefault(); return; }
          var trap = form.querySelector('#PbWebsite');
          if (trap && trap.value) { submitEvent.preventDefault(); return; }
          if (!form.checkValidity()) return;
          form.dataset.submitting = 'true';
          form.setAttribute('aria-busy', 'true');
          var button = form.querySelector('[data-pb-submit]');
          if (button) { button.disabled = true; button.textContent = 'Joining…'; }
        });
        window.addEventListener('pageshow', function () {
          delete form.dataset.submitting;
          form.removeAttribute('aria-busy');
          var button = form.querySelector('[data-pb-submit]');
          if (button) { button.disabled = false; button.innerHTML = 'Keep me posted <span aria-hidden="true">↗</span>'; }
        });
      }
    }
  }

  function ready() { document.querySelectorAll('[data-protein-black]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', ready);
}());
